<template>
  <v-menu offset-y left>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        small
        text
        color="primary"
        v-bind="attrs"
        v-on="on"
        :disabled="!normalizedActions.length"
        :title="tooltip"
      >
        <v-icon small>{{ icon }}</v-icon>
      </v-btn>
    </template>

    <v-list dense class="py-1">
      <template v-for="action in normalizedActions">
        <v-list-item
          v-if="action.to"
          :key="action.key"
          :to="action.to"
          :disabled="action.disabled"
          :title="action.hint || action.label"
          link
          @click="handleSelect(action)"
        >
          <v-list-item-icon
            v-if="action.icon"
            class="mr-3 my-0 align-self-center"
          >
            <v-icon
              small
              :class="{ 'row-actions-menu__icon--loading': action.loading }"
            >
              {{ action.icon }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ action.label }}</v-list-item-title>
            <v-list-item-subtitle v-if="action.hint">
              {{ action.hint }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-else-if="action.href"
          :key="action.key"
          :href="action.href"
          :target="action.target"
          :rel="
            action.rel ||
            (action.target === '_blank' ? 'noopener noreferrer' : undefined)
          "
          :disabled="action.disabled"
          :title="action.hint || action.label"
          link
          @click="handleSelect(action)"
        >
          <v-list-item-icon
            v-if="action.icon"
            class="mr-3 my-0 align-self-center"
          >
            <v-icon
              small
              :class="{ 'row-actions-menu__icon--loading': action.loading }"
            >
              {{ action.icon }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ action.label }}</v-list-item-title>
            <v-list-item-subtitle v-if="action.hint">
              {{ action.hint }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-else
          :key="action.key"
          :disabled="action.disabled"
          :title="action.hint || action.label"
          @click="handleSelect(action)"
        >
          <v-list-item-icon
            v-if="action.icon"
            class="mr-3 my-0 align-self-center"
          >
            <v-icon
              small
              :class="{ 'row-actions-menu__icon--loading': action.loading }"
            >
              {{ action.icon }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ action.label }}</v-list-item-title>
            <v-list-item-subtitle v-if="action.hint">
              {{ action.hint }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "RsRowActionsMenu",
  props: {
    actions: {
      type: Array,
      required: false,
      default: () => [],
    },
    icon: {
      type: String,
      required: false,
      default: "mdi-dots-vertical",
    },
    tooltip: {
      type: String,
      required: false,
      default: "Diğer işlemler",
    },
  },
  computed: {
    normalizedActions() {
      return (this.actions || [])
        .filter((action) => action && action.label)
        .map((action, index) => ({
          key: action.key || `${action.label}-${index}`,
          disabled: false,
          ...action,
        }));
    },
  },
  methods: {
    handleSelect(action) {
      if (action.disabled) {
        return;
      }

      this.$emit("select", action);
    },
  },
};
</script>

<style scoped>
.row-actions-menu__icon--loading {
  animation: row-actions-menu-spin 0.8s linear infinite;
}

@keyframes row-actions-menu-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
